import { addProduct } from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import { gsap, Power4, MotionPathPlugin } from "gsap/all"
//import { Draggable } from "gsap/Draggable"
//import MotionPathPlugin from "gsap/MotionPathPlugin"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import React, { Component } from "react"
import "./AmuletItem.scss"
//import { ReactComponent as RemoveAmulet } from "assets/temp/icons/icon-remove-amulet.svg"
import { getFadedButtonStyles } from "components/DYStackers/styles"
import Draggable from "gsap/Draggable"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"

gsap.registerPlugin(MotionPathPlugin, Draggable)

class AmuletItem extends Component {
  constructor(props) {
    super(props)
    this.setDraggingState(false)
  }

  state = {
    edge: 0,
    isDragging: false,
    isLoaded: false,
  }

  componentDidMount() {
    const { id } = this.props
    this.drag = Draggable.create(`#amulet${id}`, {
      type: "top",
      onDragEnd: () => {
        const multiplier = isMobile() ? 1.3 : 1.04
        this.setDraggingState(false)
        this.start(this.state.edge * multiplier)
      },
      onDragStart: () => this.setDraggingState(true),
      onDrag: this.update,
      onDragParams: [this],
    })
    window.addEventListener("resize", this.onWindowResize)
  }

  componentDidUpdate(prevProps, prevState) {
    const { to } = prevProps
    const { isLoaded: prevIsReady } = prevState
    const { isDragging, isLoaded } = this.state
    const { isRearrange } = this.props

    if (this.drag[0]) {
      if (isRearrange) {
        this.drag[0].enable()
      } else {
        this.drag[0].disable()
      }
    }

    if (to !== this.props.to) {
      if (!isDragging) {
        this.start(to)
        return
      }
    }

    if (!prevIsReady && isLoaded) {
      this.start()
      return
    }

    if (to === 0.5 && this.props.to === 0.5) {
      this.start(to)
      return
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize)
  }

  onAmuletImageLoad = () => {
    this.setState({ isLoaded: true })
  }

  onWindowResize = () => {
    const { id, scale, to, onComplete = () => null } = this.props

    gsap.to(`#amulet${id}`, {
      onComplete: () => onComplete(),
      duration: 0,
      scale,
      motionPath: {
        align: "#path",
        alignOrigin: [0.5, 0.07],
        end: to,
        path: "#path",
        start: to,
      },
    })
  }

  getRef = (ref) => {
    this.amuletRef = ref
  }

  setDraggingState = (state) => {
    const { isDragging } = this.state
    if (isDragging !== state) this.setState({ isDragging: state })
  }

  update(scope) {
    const edge = scope.props.getEdge()
    const { id, scale, onDrag } = scope.props
    const { target } = this

    const multiplier = isMobile() ? 1.3 : 1.04
    const edgeMin = 0.05
    const edgeMax = isMobile() ? 0.75 : 0.9

    if (edge <= edgeMin || edge >= edgeMax) {
      return
    }

    gsap.to(`#${target.id}`, {
      duration: 0,
      scale,
      motionPath: {
        align: "#path",
        alignOrigin: [0.5, 0.07],
        autoRotate: true,
        end: edge * multiplier,
        path: "#path",
        start: edge * multiplier,
      },
    })

    onDrag(id, edge * multiplier)

    scope.setState({ edge })
  }

  start(from = 1) {
    const { id, duration, delay, scale, to } = this.props
    const rotation = from > to ? 180 : 0

    gsap.to(`#amulet${id}`, {
      duration: 0,
      scale,
    })

    gsap.to(`#amulet${id}`, {
      ease: Power4.easeOut,
      delay,
      duration,
      motionPath: {
        align: "#path",
        alignOrigin: [0.5, 0.07],
        autoRotate: rotation,
        end: to,
        path: "#path",
        start: from,
      },
    })
  }

  render() {
    const { id, isVehicle, isRearrange, location, scale, src, navigate } =
      this.props
    const { isLoaded } = this.state
    const amuletAnimClasses = classNames("amulet-anim", {
      "d-inline-block": isLoaded,
    })
    const removeAmuletClasses = classNames("btn btn-icon remove-amulet", {
      "remove-amulet-vehicle": isVehicle,
    })

    return (
      <div id={`container-amulet${id}`} className="container-amulet">
        <div
          id={`amulet${id}`}
          className={amuletAnimClasses}
          ref={this.getRef}
          style={{ scale }}
        >
          {isRearrange && (
            <button
              className={removeAmuletClasses}
              onClick={() => addProduct(id, location, navigate)}
            >
              {/* <RemoveAmulet alt="Remove" style={getFadedButtonStyles()} /> */}
              <img
                alt="Remove"
                style={getFadedButtonStyles()}
                src={`${AEM_ASSETS}/temp/icons/icon-remove-amulet.svg`}
              />
            </button>
          )}
          <div className="amulet-anim-img-container">
            <div className="amulet-anim-img">
              <img
                alt="Amulet"
                src={src}
                onLoad={this.onAmuletImageLoad}
                height="560"
                width="485"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AmuletItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  delay: PropTypes.number,
  duration: PropTypes.number,
  id: PropTypes.string.isRequired || PropTypes.number.isRequired,
  isRearrange: PropTypes.bool.isRequired,
  isVehicle: PropTypes.bool.isRequired,
  location: PropTypes.object,
  scale: PropTypes.number,
  src: PropTypes.string.isRequired,
  to: PropTypes.number.isRequired,
  onComplete: PropTypes.func,
  navigate: PropTypes.func,
  onDrag: PropTypes.func,
  getEdge: PropTypes.func,
}

export default AmuletItem
